import logo from "../../assets/logo-white.svg";
import { LogoutButton } from "../auth/LogoutButton";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

export const ProgramSelector = () => {
  return (
    <div className="flex items-center gap-2 border border-neutral-200 rounded-lg py-1 px-2 bg-[#A966AA]/10 shadow-xs">
      <div className="flex items-center bg-[#A966AA] p-2 rounded-lg">
        <img src={logo} alt="Amos Institute Logo" className="h-5" />
      </div>
      <div className="tracking-tight text-base text-neutral-900">
        Cognitive Health Program
      </div>
    </div>
  );
};

export const Navigation = () => {
  return (
    <Card>
      <CardContent className="flex justify-between items-center p-2 text-lg">
        <ProgramSelector />
        <div className="flex items-center gap-2">
          <Button variant="link" asChild>
            <a href="https://amosinstitute.com/contact">Contact Us</a>
          </Button>
          <Button variant="link" asChild>
            <a href="https://amosinstitute.com/blog">Blog</a>
          </Button>
          <LogoutButton />
        </div>
      </CardContent>
    </Card>
  );
};
